module.exports = "<p>\n  download works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/views/dpr/download.component.html
// module id = ./src/app/views/dpr/download.component.html
// module chunks = main